export default __webpack_public_path__ + "files/NGREC-2fd8e93b535b2e8347679d742acf9c42.jpg";